import PubSub from "underpub-js";

var AnimationConfetti = function(options) {

	this.options = {
		$el: false,
		baseClass: 'atom-AnimationConfetti',
	};

	$.extend(true, this.options, options);

};

AnimationConfetti.prototype.init = function() {

	var self = this;

};

export default AnimationConfetti;
